import { Flex, useToasts } from '@applyboard/crystal-ui';
import { Navigate, useNavigate } from 'react-router-dom';
import { formatErrorMessage } from '../../utils';
import { CreateAgencyProps, UserType } from '../../clients';
import { NavBars } from '../../components/NavBars';
import { PageHeading } from '../../components/PageHeading';
import { useProfile } from '../../hooks';
import { LoadingPage } from '../LoadingPage';
import { AgencyForm } from '../../components/AgencyForm';
import { useCreateAgency } from '../../hooks/agencies/useCreateAgency';

export function AddAgencyPage(): JSX.Element {
  const { createAgency, isCreatingAgency } = useCreateAgency();
  const navigate = useNavigate();
  const toasts = useToasts();
  const { profileData: currentSessionUser, isGetProfileLoading: isGetCurrentSessionUserLoading } = useProfile();
  const currentSessionUserIsResolved = !isGetCurrentSessionUserLoading && currentSessionUser;

  if (!currentSessionUserIsResolved) {
    return <LoadingPage />;
  }

  if (currentSessionUser.userType !== UserType.admin && currentSessionUser.userType !== UserType.owner) {
    toasts.warning(`You don't have permission to see this page`);
    return <Navigate to={'/profiles/agencies'} />;
  }

  const handleSubmit = (agencyData: CreateAgencyProps) => {
    createAgency(agencyData, {
      onSuccess: () => {
        navigate('/profiles/agencies');
        toasts.positive('Added agency successfully.');
      },
      onError: (error) => {
        const formattedError = formatErrorMessage(error as Error);
        toasts.negative(formattedError);
      },
    });
  };

  return (
    <NavBars selectedMenuItem="All Users">
      <Flex p={{ xs: 4, sm: 12 }} direction="column">
        <PageHeading title="Add Agency" imageSrc="/user-management-icon.svg" imageAlt="add agency icon" />
        <AgencyForm onSubmit={handleSubmit} isLoading={isCreatingAgency} />
      </Flex>
    </NavBars>
  );
}
